import { Injectable } from '@angular/core';
import { ModalRef } from '@ecs-services/modal/modal-ref';
import { ModalService } from '@ecs-services/modal/modal.service';
import { SafetyHintDialogComponent, SafetyHintDialogData } from './safety-hint-dialog.component';

@Injectable({
    providedIn: 'root',
})
export class SafetyHintDialogService {
    public constructor(private modalService: ModalService) {}

    public showSafetyHintDialog(
        configuration: {
            type: string;
            headline: string;
            label: string;
            status: string;
            open: boolean;
            size: string;
        },
        data: SafetyHintDialogData
    ): ModalRef<typeof SafetyHintDialogComponent> {
        return this.modalService.openDialog({
            component: SafetyHintDialogComponent,
            configuration: { ...configuration, closeButton: false },
            data,
        });
    }
}
